import { SCORING_SYSTEM } from '@colven/common-domain-lib/lib'
import i18n from '@/i18n'
import { mapActions } from 'vuex'
import { DialogScoring } from "@/tools/dialog"
import { EventHub } from "@/constants/constants"

export default {
    name: 'EnterpriseDialogScoringTabComponent',
    components: {
    },
    model: {
        prop: 'model',
        event: 'change'
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        validationRules: {
            type: Object,
            required: true
        },
        validForm: {
            type: Boolean,
            required: true
        },
        resetFormValidation: {
            type: Boolean,
            required: true
        },
        update: {
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        // model para el formulario
        isValidForm: false,
        // sistemas de puntajes
        scoringSystems: [
            {
                id: SCORING_SYSTEM.ADDITION,
                name: i18n.t('scoring.editDialog.addition')
            },
            {
                id: SCORING_SYSTEM.SUBSTRACTION,
                name: i18n.t('scoring.editDialog.substraction')
            }
        ],
        // referencia a las constantes del common domain, para usarlas en el template
        scoringSystemConstants: SCORING_SYSTEM,
    }),
    computed: {
        /**
         * ícono del selector del sistema de puntaje
         */
        scoringSystemIcon () {
            if (this.model.scoringSystem === SCORING_SYSTEM.ADDITION) {
                return 'mdi-plus-box'
            } else if (this.model.scoringSystem === SCORING_SYSTEM.SUBSTRACTION) {
                return 'mdi-minus-box'
            } else {
                return 'mdi-plus-minus-box'
            }
        },
        /**
         * Validación de completitud del nivel 1
         */
        firstLevelValidation () {
            let firstLevelValidation = false;
            this.model.firstLevel.forEach(element => {
                firstLevelValidation = element.immunity !== null && element.name !== null && element.reference !== null
                    && element.sligth !== null && element.sligth.key !== null && element.sligth.weightedValue !== null && element.sligth.range.min !== null && element.sligth.range.max !== null
                    && element.medium !== null && element.medium.key !== null && element.medium.weightedValue !== null && element.medium.range.min !== null && element.medium.range.max !== null
                    && element.serious !== null && element.serious.key !== null && element.serious.weightedValue !== null && element.serious.range.min !== null && element.serious.range.max == null
            })
            return firstLevelValidation
        },
        /**
         * Validación de completitud del nivel 2
         */
        secondLevelValidation () {
            const secondLevelInfractions = ['hardBraking', 'acceleration', 'corneringAcceleration', 'disconnection']
            const ranges = ['sligth', 'medium', 'serious']

            let secondLevelValidation = true
                && this.model.secondLevel.timeWindow != null
            let i = 0
            while (i < secondLevelInfractions.length && secondLevelValidation) {
                let r = 0
                while (r < ranges.length && secondLevelValidation) {
                    secondLevelValidation = secondLevelValidation
                        && this.model.secondLevel[secondLevelInfractions[i]][ranges[r]].range.min != null
                        && ((this.model.secondLevel[secondLevelInfractions[i]][ranges[r]].range.max != null) || (ranges[r] === 'serious' && (this.model.secondLevel[secondLevelInfractions[i]][ranges[r]].range.max == null)))
                        && this.model.secondLevel[secondLevelInfractions[i]][ranges[r]].weightedValue != null
                    r++
                }
                i++
            }

            return secondLevelValidation
        },
        /**
         * Validación de completitud del nivel 3
         */
        thirdLevelValidation () {
            const thirdLevelInfractions = ['ralenti', 'continuousDriving', 'nightDriving', 'incompleteRest']
            const ranges = ['sligth', 'medium', 'serious']

            let thirdLevelValidation = true
                && this.model.thirdLevel.maxStopTime != null
                && this.model.thirdLevel.nightSchedule.start != null
                && this.model.thirdLevel.nightSchedule.end != null
            let j = 0
            while (j < thirdLevelInfractions.length && thirdLevelValidation) {
                let r = 0
                while (r < ranges.length && thirdLevelValidation) {
                    thirdLevelValidation = thirdLevelValidation 
                        && this.model.thirdLevel[thirdLevelInfractions[j]][ranges[r]].range.min != null
                        && ((this.model.thirdLevel[thirdLevelInfractions[j]][ranges[r]].range.max != null) || (ranges[r] === 'serious' && (this.model.thirdLevel[thirdLevelInfractions[j]][ranges[r]].range.max == null)))
                        && this.model.thirdLevel[thirdLevelInfractions[j]][ranges[r]].weightedValue != null
                    r++
                }
                j++
            }

            return thirdLevelValidation
        }
    },
    created () {
        // Evento lanzado por el diálogo de creación de línea, cuando se guarda la nueva línea
        this.$eventBus.$on(EventHub.COMMIT_SCORING_CONFIGURATION, (scoringConfiguration) => {
            this.updateScoringConfiguration(scoringConfiguration)
        })
        
    },
    mounted () {
    },
    methods: {
        /**
         * actions del breadcrumb
         */
        ...mapActions('breadcrumbs', [
            'pushBread'
        ]),
        /**
         * Abre el dialog para editar la configuración de scoring de conductores
         * @param {*} level
         * @param {*} view
         */
        openScoringDialog (tab, view = false) {
            const bread = {
                key: DialogScoring,
                disabled: true,
                text: this.$t('scoring.name'),
                model: this.model,
                tab: `tab-${tab}`,
                update: this.update,
                view
            }
            this.pushBread(bread)
        },
        /**
         * Luego de guardar la configuración de scoring en el dialog, actualizo los valores en el modelo
         * @param {*} scoringConfiguration
         */
        updateScoringConfiguration (scoringConfiguration) {
            this.model.firstLevel = scoringConfiguration.firstLevel
            this.model.secondLevel = scoringConfiguration.secondLevel
            this.model.thirdLevel = scoringConfiguration.thirdLevel
        },
        /**
         * Setea en null el valor del model
         */
        clearAdditionMaxValue () {
            this.model.additionMaxValue = null
            this.$refs.enterpriseScoringForm.resetValidation()
        },
        /**
         * Setea en null el valor del model
         */
        clearAdditionMclearSubstractionMinValueaxValue () {
            this.model.additionMaxValue = null
            this.$refs.enterpriseScoringForm.resetValidation()
        }
    },
    watch: {
        isValidForm (newVal, oldVal){
            if(newVal!==oldVal){
                this.$emit('update:validForm', newVal)
            }
        },
        /**
         * Para restablecer las validaciones del formulario
         * @param {*} newVal
         */
        resetFormValidation (newVal) {
            if (newVal && this.$refs.enterpriseDataForm) {
                this.$refs.enterpriseScoringForm.resetValidation()
            }
        },
        maxSpeedHeavy(newValue){
            this.model.maxSpeedHeavy = newValue
        },
        'model.scoringSystem': {
            handler: function (newVal) {
                if (newVal === SCORING_SYSTEM.ADDITION) {
                    this.model.substractionInitialValue = null
                } else if (newVal === SCORING_SYSTEM.SUBSTRACTION) {
                    this.model.additionMaxValue = null
                } else {
                    this.model.substractionInitialValue = null
                    this.model.additionMaxValue = null
                }
            }
        }
    }
}
